import { Tabs, TextInput } from '@ts/storybook';
import { IForm } from '@ts/ui-models';
import { useState } from 'react';
import DeviceTypeEvents from './DeviceTypeEvents';

const DeviceTypeForm = (props: IForm) => {
  const [activeTab, setActiveTab] = useState<'main' | 'events&Readings'>('main');
  const isViewMode = props.mode === 'view';

  const tabs = [
    { label: 'Main', value: 'main' },
    { label: 'Events & Readings', value: 'events&Readings' },
  ];

  const renderMain = () => (
    <TextInput isReadOnly={isViewMode} label="Name" value={props.values.name} onChangeValue={props.onCallbackChange('name')} />
  );

  const renderContent = () => {
    switch (activeTab) {
      case 'main':
        return renderMain();
      case 'events&Readings':
        return <DeviceTypeEvents {...props} />;
      default:
        return;
    }
  };

  return (
    <Tabs id="device-type-page" tabs={tabs} value={activeTab} onChange={(_, tab) => setActiveTab(tab)}>
      {renderContent()}
    </Tabs>
  );
};

export default DeviceTypeForm;
